var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcluirMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "excluir-material",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.917,
    height: 18.483,
    viewBox: "0 0 16.917 18.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M21.738,5.558H23V17.852a.632.632,0,0,0,.63.63H35.188a.632.632,0,0,0,.63-.63V5.558h1.576a.63.63,0,0,0,0-1.261H34.389a4.487,4.487,0,0,0-1.145-2.9A4.981,4.981,0,0,0,29.451,0a4.565,4.565,0,0,0-3.678,1.408,4.177,4.177,0,0,0-.883,2.89H21.738a.63.63,0,1,0,0,1.261Zm4.981-3.341a3.381,3.381,0,0,1,2.721-.956,3.81,3.81,0,0,1,2.869.988A3.268,3.268,0,0,1,33.118,4.3H26.152A2.977,2.977,0,0,1,26.719,2.217Zm7.839,3.341V17.222H24.26V5.558Z",
    transform: "translate(-21.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M174.738,195.228a.632.632,0,0,0,.63-.63v-7.25a.63.63,0,1,0-1.261,0v7.25A.632.632,0,0,0,174.738,195.228Z",
    transform: "translate(-168.434 -179.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M282.405,195.228a.632.632,0,0,0,.63-.63v-7.25a.63.63,0,1,0-1.261,0v7.25A.632.632,0,0,0,282.405,195.228Z",
    transform: "translate(-272.108 -179.793)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluirMaterial);
export default __webpack_public_path__ + "static/media/excluir-material.88109410515ad2fccc07428e4a6e1868.svg";
export { ForwardRef as ReactComponent };